import { AfterViewInit, Component, OnDestroy ,Input, Output,EventEmitter} from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import * as internal from 'stream';

@Component({
  selector: 'app-my-pie',
  template: `
    <div style="width:100%">
      <div echarts [options]="options" class="echart"  style="height:300px;"></div>
    </div>
  `,
})
export class MyPieComponent implements AfterViewInit, OnDestroy {
  @Output() emitList = new EventEmitter();
  @Input() orgData: pieData;  //已選資料_來源
  @Input() title: string; 
  @Input() datatitle: string; 


  options: any = {};
  themeSubscription: any;

  constructor(private theme: NbThemeService) {
  }

  ngAfterViewInit() {
    this.themeSubscription = this.theme.getJsTheme().subscribe(config => {

      const colors = config.variables;
      const echarts: any = config.variables.echarts;

      this.options = {
        title: {
          text: this.title,
          left: 'center',
          top:0,
          
        },
        height:250,
        color: [colors.warningLight, colors.infoLight, colors.dangerLight, colors.successLight, colors.primaryLight],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['USA', 'Germany', 'France', 'Canada', 'Russia'],
          // textStyle: {
          //   color: echarts.textColor,
          // },
        },
        series: [
          {
            top:10,
            name: this.datatitle ? this.datatitle : this.title,
            type: 'pie',
            data: this.orgData ,
            //  [
            //   { name: '银河帝国5：迈向基地', value: 18.8 },
            //   { name: '俞军产品方法论', value: 25.3 },
            //   { name: '艺术的逃难', value: 12.2 },
            //   { name: '第一次世界大战回忆录（全五卷）', value: 1.3 },
            //   { name: 'Scrum 精髓', value: 1.2 },
            //   { name: '其它', value: 15.7 }
            // ],
            radius: [30, 100],
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              alignTo: 'labelLine',
              // formatter: '{name|{b}}\n{time|{c} 小时}',
              minMargin: 15,
              bleedMargin: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: '#999'
                }
              }
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < 100 / 2;
              const points = params.labelLinePoints as number[][];
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
      
              return {
                labelLinePoints: points
              };
            },
           
            
          },
        ],
      };
    });




  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }
}


class pieData  {
  name:string
  value:internal
}
